import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private requests = 0;
  readonly isLoading = signal(false);

  show(): void {
    this.requests += 1;
    this.isLoading.set(true);
  }

  hide(): void {
    this.requests = Math.max(0, this.requests - 1);
    this.isLoading.set(this.requests > 0);
  }
}
